import React from 'react';
import { Helmet } from 'react-helmet-async';
import { siteMeta } from '../data/mock';

/**
 * SchemaMarkup Component
 * Generates JSON-LD for Organization and ProfessionalService
 */
const SchemaMarkup = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": siteMeta.name,
    "url": "https://meraki-solutions.in",
    "logo": `https://meraki-solutions.in${siteMeta.logo}`,
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": siteMeta.phone,
      "contactType": "customer service",
      "email": siteMeta.email,
      "areaServed": "Worldwide",
      "availableLanguage": "en"
    },
    "sameAs": [
      siteMeta.socials.linkedin,
      siteMeta.socials.instagram,
      siteMeta.socials.youtube
    ]
  };

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": siteMeta.name,
    "image": `https://meraki-solutions.in${siteMeta.logo}`,
    "@id": "https://meraki-solutions.in",
    "url": "https://meraki-solutions.in",
    "telephone": siteMeta.phone,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "26-B, Indrapuri",
      "addressLocality": "Bhopal",
      "addressRegion": "Madhya Pradesh",
      "postalCode": "462021",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 23.2599,
      "longitude": 77.4126
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday"
      ],
      "opens": "09:00",
      "closes": "18:00"
    },
    "priceRange": "$$$"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(serviceSchema)}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup;
